import React from 'react';
import { usePageSEO } from '../hooks/usePageSEO';
import { organizationSchema, websiteSchema, faqSchema } from '../utils/structuredData';
import { HeroSection } from '../components/home/HeroSection';
import { AuthoritySection } from '../components/home/AuthoritySection';
import { WhatWeDoSection } from '../components/home/WhatWeDoSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { ProductsSection } from '../components/home/ProductsSection';
import { LatestReleaseSection } from '../components/home/LatestReleaseSection';
import { PortfolioSection } from '../components/home/PortfolioSection';
import { WhyChooseUsSection } from '../components/home/WhyChooseUsSection';
import { ProcessSection } from '../components/home/ProcessSection';
import { TrustedBySection } from '../components/home/TrustedBySection';
import { FeaturedRecognitionSection } from '../components/home/FeaturedRecognitionSection';
import { CTASection } from '../components/home/CTASection';
export function HomePage() {
  usePageSEO({
    canonical: '/',
    keywords: 'Shopify development agency, Shopify experts, custom Shopify themes, Shopify app development, ecommerce conversion optimization, Fiverr top rated Shopify',
    jsonLd: [organizationSchema, websiteSchema, faqSchema([{
      question: 'What does Design Flow Digitals do?',
      answer: 'Design Flow Digitals is a premium Shopify development agency. We build custom Shopify themes, develop high-performance Shopify apps, create full ecommerce stores, and run conversion rate optimization for merchants worldwide.'
    }, {
      question: 'How many Shopify stores has Design Flow Digitals built?',
      answer: 'Design Flow Digitals has delivered more than 1,000 Shopify stores for global brands and entrepreneurs.'
    }, {
      question: 'Who founded Design Flow Digitals?',
      answer: 'Design Flow Digitals was founded by Pankaj Maurya, a full-stack Shopify developer with a Master of Commerce and a top-rated profile on Fiverr.'
    }, {
      question: 'Which Shopify apps does Design Flow Digitals offer?',
      answer: 'Design Flow Digitals offers two live Shopify apps: SEO Suite, an all in one Shopify SEO toolkit, and AI Photoshoot, an AI powered product photography app.'
    }])],
    title: 'Design Flow Digitals',
    description: 'Design Flow Digitals is a premium Shopify development agency with 1,000+ stores delivered. We specialize in custom themes, high-performance apps, and conversion-focused ecommerce stores for global merchants.'
  });
  return <div className="flex flex-col w-full" data-id="element-1041">
      <HeroSection data-id="element-1042" />
      <AuthoritySection data-id="element-1043" />
      <WhatWeDoSection data-id="element-1044" />
      <ServicesSection data-id="element-1045" />
      <ProductsSection data-id="element-1046" />
      <LatestReleaseSection data-id="element-1047" />
      <PortfolioSection data-id="element-1048" />
      <WhyChooseUsSection data-id="element-1049" />
      <ProcessSection data-id="element-1050" />
      <TrustedBySection data-id="element-1051" />
      <FeaturedRecognitionSection data-id="element-1052" />
      <CTASection data-id="element-1053" />
    </div>;
}